import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { TopographNavbar } from './components/TopographNavbar';
import { Index } from './pages/Index';
import { Create } from './pages/Create';
import { Renders } from './pages/Renders';
import { Checkout } from './pages/Checkout';
import { Orders } from './pages/Orders';
import { Admin } from './pages/Admin';
import { Login } from './pages/Login';
import 'maplibre-gl/dist/maplibre-gl.css';

function Placeholder({ name }: { name: string }) {
  return (
    <>
      <TopographNavbar />
      <div style={{ padding: '2rem', color: '#FFBF00' }}>
        <p>
          <code>{name}</code> — placeholder. Port in progress.
        </p>
      </div>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/create" element={<Create />} />
        <Route path="/renders" element={<Renders />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Placeholder name="404" />} />
      </Routes>
    </BrowserRouter>
  );
}
